// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`

// these are basic map samplers with uv scaling and offsets and such if they are defined
vec4 texelColor;
if (tpmData.useTpmMap){
	texelColor = triplanar_mapping( map, inverseTransformDirection( normalize( vNormal ), viewMatrix ), vWorldPosition, mapTpmScale );
	texelColor = mapTexelToLinear( texelColor );
	diffuseColor *= texelColor;
	// debugColor = vec4(1.0, 0.0, 1.0, 1.0);
} else {
	texelColor = texture2D( map, vUv );
	texelColor = mapTexelToLinear( texelColor );
	diffuseColor *= texelColor;
}

`;